/* eslint-disable @typescript-eslint/no-explicit-any */
import { defaultInstance } from '@ciam/async-utils';

export type AuthAPI = {
  getUserChannels: (params: { email: string }) => any;
  checkTenureStatus: (params: { uid: string }) => any;
  getMfaException: (params: { email: string }) => any;
  getBioRequiredChannels: () => any;
  initiateMfaLogin: (params: { email: string; uid: string; isBioOnly: boolean; returnUrl: string }) => Promise<string>;
  validateJwtToken: (params: { jwtTokenResponse: string; isBioOnly: boolean }) => any;
  getMfaRequired: () => any;
  setAccountStatus: (params: { uid: string; channel: string }) => any;
  consentVersionCheck: (params: { uid: string; channel: string }) => any;
};

export const authAPI: AuthAPI = {
  getUserChannels: async ({ email }) => {
    const { data } = await defaultInstance.post('/api/gigya/get-user-channel-list', { email });
    return data;
  },
  getMfaException: async ({ email }) => {
    const { data } = await defaultInstance.post('/api/gigya/get-mfa-exception', { email });
    return data;
  },
  getBioRequiredChannels: async () => {
    const { data } = await defaultInstance.get('/getBioRequired');
    return data;
  },
  initiateMfaLogin: async (params) => {
    const { email, uid, isBioOnly, returnUrl } = params;

    const { data } = await defaultInstance.post('/api/mfa/request', {
      email,
      uid,
      displayUid: email,
      isBioOnly,
      returnUrl,
    });
    return data;
  },
  validateJwtToken: async ({ jwtTokenResponse, isBioOnly }: { jwtTokenResponse: string; isBioOnly: boolean }) => {
    const { data } = await defaultInstance.post('/api/mfa/authenticate', {
      jwtTokenResponse,
      isBioOnly,
    });
    return data;
  },
  checkTenureStatus: async ({ uid }) => {
    const { data } = await defaultInstance.post('/check-tenure', { uid });
    return data;
  },
  getMfaRequired: async () => {
    const { data } = await defaultInstance.get('/getMfaRequired');
    return data;
  },
  setAccountStatus: async ({ uid, channel }: { uid: string; channel: string }) => {
    const res = await defaultInstance.post('/setAccountStatus', { uid, channel });
    return res;
  },
  consentVersionCheck: async ({ uid, channel }: { uid: string; channel: string }) => {
    const { data } = await defaultInstance.post('/new-consent/consentVersionCheck', { uid, channel });
    return data;
  },
};
